var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHornInactiveSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.7568359,4c-0.8300781,0-1.5908203,0.4609375-1.9863281,1.203125C26.0341797,8.453125,24.2792969,10,19,10h-7V9 c0-1.6542969-1.3457031-3-3-3H3C1.3457031,6,0,7.3457031,0,9v10c0,1.6542969,1.3457031,3,3,3h6c1.6542969,0,3-1.3457031,3-3v-1h7 c3.4246216,0,5.362793,0.6554565,6.7780151,2h2.6218262C26.572937,17.4414062,24.0737305,16,19,16h-7v-4h7 c6.1953125,0,8.5537109-2.1464844,10.5351562-5.8554688C29.6523438,5.9228516,29.9990234,6.0195312,30,6.2431641V20h2V6.2431641 C32,5.0058594,30.9941406,4,29.7568359,4z M10,19c0,0.5517578-0.4482422,1-1,1H3c-0.5517578,0-1-0.4482422-1-1V9 c0-0.5517578,0.4482422-1,1-1h6c0.5517578,0,1,0.4482422,1,1V19z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.2929688,22.2929688 27,25.5859375 23.7070312,22.2929688 22.2929688,23.7070312 25.5859375,27  22.2929688,30.2929688 23.7070312,31.7070312 27,28.4140625 30.2929688,31.7070312 31.7070312,30.2929688 28.4140625,27  31.7070312,23.7070312  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHornInactiveSmall);
export default __webpack_public_path__ + "static/media/horn-inactive--small.df62f350ba336aaa19ba5ab669ae8bb6.svg";
export { ForwardRef as ReactComponent };